export default __webpack_public_path__ + "static/media/HNPF-logo.1fa12587.png";